export const FETCH_CONTRACTOR_JOBS_REQUEST = 'FETCH_CONTRACTOR_JOBS_REQUEST';
export const FETCH_CONTRACTOR_JOBS_SUCCESS = 'FETCH_CONTRACTOR_JOBS_SUCCESS';
export const FETCH_CONTRACTOR_JOBS_FAIL = 'FETCH_CONTRACTOR_JOBS_FAIL';

export const FETCH_CONTRACTOR_JOB_DETAIL_REQUEST =
  'FETCH_CONTRACTOR_JOB_DETAIL_REQUEST';
export const FETCH_CONTRACTOR_JOB_DETAIL_SUCCESS =
  'FETCH_CONTRACTOR_JOB_DETAIL_SUCCESS';
export const FETCH_CONTRACTOR_JOB_DETAIL_FAIL =
  'FETCH_CONTRACTOR_JOB_DETAIL_FAIL';

export const UPDATE_CONTRACTOR_JOB_REQUEST = 'UPDATE_CONTRACTOR_JOB_REQUEST';
export const UPDATE_CONTRACTOR_JOB_SUCCESS = 'UPDATE_CONTRACTOR_JOB_SUCCESS';
export const UPDATE_CONTRACTOR_JOB_FAIL = 'UPDATE_CONTRACTOR_JOB_FAIL';

export const ACCEPT_OR_DECLINE_JOB_REQUEST = 'ACCEPT_OR_DECLINE_JOB_REQUEST';
export const ACCEPT_OR_DECLINE_JOB_SUCCESS = 'ACCEPT_OR_DECLINE_JOB_SUCCESS';
export const ACCEPT_OR_DECLINE_JOB_FAIL = 'ACCEPT_OR_DECLINE_JOB_FAIL';
export const ACCEPT_OR_DECLINE_JOB_RESET = 'ACCEPT_OR_DECLINE_JOB_RESET';

export const DELETE_BULK_CONTRACTOR_JOB_REQUEST =
  'DELETE_BULK_CONTRACTOR_JOB_REQUEST';
export const DELETE_BULK_CONTRACTOR_JOB_SUCCESS =
  'DELETE_BULK_CONTRACTOR_JOB_SUCCESS';
export const DELETE_BULK_CONTRACTOR_JOB_FAIL =
  'DELETE_BULK_CONTRACTOR_JOB_FAIL';

export const CANCEL_JOB_REQUEST = 'CANCEL_JOB_REQUEST';
export const CANCEL_JOB_SUCCESS = 'CANCEL_JOB_SUCCESS';
export const CANCEL_JOB_FAIL = 'CANCEL_JOB_FAIL';

export const ARCHIVE_MEMO_REQUEST = 'ARCHIVE_MEMO_REQUEST';
export const ARCHIVE_MEMO_SUCCESS = 'ARCHIVE_MEMO_SUCCESS';
export const ARCHIVE_MEMO_FAIL = 'ARCHIVE_MEMO_FAIL';

export const DELETE_SINGLE_JOB_MEMO_REQUEST = 'DELETE_SINGLE_JOB_MEMO_REQUEST';
export const DELETE_SINGLE_JOB_MEMO_SUCCESS = 'DELETE_SINGLE_JOB_MEMO_SUCCESS';
export const DELETE_SINGLE_JOB_MEMO_FAIL = 'DELETE_SINGLE_JOB_MEMO_FAIL';

export const FETCH_ARCHIVED_MEMO_REQUEST = 'FETCH_ARCHIVED_MEMO_REQUEST';
export const FETCH_ARCHIVED_MEMO_SUCCESS = 'FETCH_ARCHIVED_MEMO_SUCCESS';
export const FETCH_ARCHIVED_MEMO_FAIL = 'FETCH_ARCHIVED_MEMO_FAIL';

export const DELETE_BULK_ARCHIVED_MEMO_REQUEST =
  'DELETE_BULK_ARCHIVED_MEMO_REQUEST';
export const DELETE_BULK_ARCHIVED_MEMO_SUCCESS =
  'DELETE_BULK_ARCHIVED_MEMO_SUCCESS';
export const DELETE_BULK_ARCHIVED_MEMO_FAIL = 'DELETE_BULK_ARCHIVED_MEMO_FAIL';

export const FETCH_DECLINED_MEMO_REQUEST = 'FETCH_DECLINED_MEMO_REQUEST';
export const FETCH_DECLINED_MEMO_SUCCESS = 'FETCH_DECLINED_MEMO_SUCCESS';
export const FETCH_DECLINED_MEMO_FAIL = 'FETCH_DECLINED_MEMO_FAIL';

export const DELETE_BULK_DECLINED_MEMO_REQUEST =
  'DELETE_BULK_DECLINED_MEMO_REQUEST';
export const DELETE_BULK_DECLINED_MEMO_SUCCESS =
  'DELETE_BULK_DECLINED_MEMO_SUCCESS';
export const DELETE_BULK_DECLINED_MEMO_FAIL = 'DELETE_BULK_DECLINED_MEMO_FAIL';

export const FETCH_JOB_COUNTER_REQUEST = 'FETCH_JOB_COUNTER_REQUEST';
export const FETCH_JOB_COUNTER_SUCCESS = 'FETCH_JOB_COUNTER_SUCCESS';
export const FETCH_JOB_COUNTER_FAIL = 'FETCH_JOB_COUNTER_FAIL';
